module.exports = __webpack_public_path__ + "img/42.supervise.e9fa375d.svg";